import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1422Model } from "../kymw1422.model";

/**
 * W掲載元(親)を更新するサービス
 *
 * @export UpdateParentChildDivService
 * @class UpdateParentChildDivService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateParentChildDivService extends PlessJsonResponderSub<unknown> {
  private model: KYMW1422Model;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateParentChildDivService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        ParentChildDiv: {
          combination: this.model.wPublishedGoodsList.map(goods => {
            return goods.wPublishedPages.map(page => ({
              parameter: {
                PCode: goods.pCode,
                KomaID: page.komaId,
                ParentChildDiv: page.parentChildDiv
              }
            }));
          }).reduce((prev, current) => {
            return [...prev, ...current];
          }, [])
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateParentChildDivService
   */
  execute(model: KYMW1422Model, successFunc?: () => void): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('updateParentChildDiv', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateParentChildDivService
   */
  success(): void {
    if (this.successFunc) {
      this.successFunc();
    }
  }
}